<template>
    <b-modal
        id="attachment-lightbox"
        size="xl"
        centered
        hide-footer
        hide-header
        body-class="p-0"
        @shown="initPanzoom"
        @hidden="destroyPanzoom">
        <div class="close-btn" @click="close"><b-icon-x/></div>
        <div class="zoom-widget">
            <button class="primary zoom-button" @click="zoom('out')">−</button>
            <div class="zoom-text">{{ zoomLabel }}</div>
            <button class="primary zoom-button" @click="zoom('in')">+</button>
        </div>
        <div ref="viewport" class="lightbox-viewport">
            <div ref="panContainer" class="pan-container">
                <img
                    v-if="src"
                    ref="image"
                    :src="src"
                    class="lightbox-image"
                    draggable="false"
                />
            </div>
        </div>
    </b-modal>
</template>

<script>
import PanZoom from 'panzoom'

export default {
    name: 'AttachmentLightbox',

    props: {
        src: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            panInstance: null,
            zoomLabel: '100%',
        }
    },

    methods: {
        close() {
            this.$bvModal.hide('attachment-lightbox')
        },

        initPanzoom() {
            if (this.panInstance) return

            this.panInstance = PanZoom(this.$refs.panContainer, {
                maxZoom: 8,
                minZoom: 0.2,
                autocenter: true,
                bounds: true,
                zoomDoubleClickSpeed: 1,
                onDoubleClick: () => false,
            })

            this.panInstance.on('zoom', (e) => {
                const scale = e.getTransform().scale
                this.zoomLabel = Math.round(scale * 100) + '%'
            })
        },

        destroyPanzoom() {
            if (this.panInstance) {
                this.panInstance.dispose()
                this.panInstance = null
                this.zoomLabel = '100%'
            }
        },

        zoom(direction) {
            if (!this.panInstance) return

            const rect = this.$refs.viewport.getBoundingClientRect()
            const factor = direction === 'in' ? 1.3 : 0.7

            this.panInstance.smoothZoom(
                rect.width / 2,
                rect.height / 2,
                factor
            )
        },
    },
}
</script>

<style scoped>
.lightbox-viewport {
    position: relative;
    width: 100%;
    height: 90vh;
    overflow: hidden;
    background: #858585;
}

.pan-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.lightbox-image {
    max-width: 100%;
    max-height: 100%;
    user-select: none;
    cursor: grab;
}

.close-btn {
    position: absolute;
    color: #000;
    font-weight: bold;
    z-index: 100;
    font-size: 30px;
    opacity: 0.4;
    top: 10px;
    right: 10px;
    font-size: 2rem;
    cursor: pointer;
}

.zoom-widget {
    display: inline-flex;
    background-color: #ffffff;
    border: solid 1px #a1a1a1;
    border-radius: 50px;
    width: fit-content;
    margin-top: 20px;
    padding: 3px 5px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 100;
}

.zoom-text {
    text-align: center;
    width: 6ch;
    padding-top: 2px;
    font-size: 1rem;
}

.zoom-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    color: white;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    background-color: #6c757d;
    border-color: #6c757d;
}

.zoom-button:hover {
    background-color: #dc2626;
    border-color: #dc2626;
}

.zoom-button:focus {
    outline: none;
}
</style>
